module.exports = __webpack_public_path__ + "static/media/leftArrow.34a4f31c.svg";